module.exports = __webpack_public_path__ + "img/logo3.480c33b1.png";